import * as L from 'leaflet'
import 'leaflet.vectorgrid'
import { WATER_SYSTEM_CONFIG } from './waterSystemConfig'
import { tileClipInsets } from './waterSystemClip.cjs'

export function createWaterSystemLayer(map) {
  const config = WATER_SYSTEM_CONFIG
  const { west, east, south, north } = config.bounds
  const bounds = L.latLngBounds([south, west], [north, east])
  const layer = L.vectorGrid.protobuf(config.url, {
    bounds: config.restrictBounds ? bounds : undefined,
    noWrap: true,
    rendererFactory: L.canvas.tile,
    interactive: false,
    updateWhenZooming: false,
    updateWhenIdle: true,
    keepBuffer: 0,
    vectorTileLayerStyles: { [config.layerName]: config.style }
  })

  if (!config.restrictBounds) return layer

  // bounds 只能筛选整块瓦片；每块瓦片还需裁剪，避免边缘水系越界。
  // 使用瓦片自身坐标，缩放动画和拖动时无需更新屏幕坐标。
  layer.on('tileloadstart', ({ tile, coords }) => {
    const northWest = map.project(bounds.getNorthWest(), coords.z)
    const southEast = map.project(bounds.getSouthEast(), coords.z)
    const insets = tileClipInsets(coords, layer.getTileSize().x, northWest, southEast)
    tile.style.clipPath = `inset(${insets.map(value => `${value}px`).join(' ')})`
  })
  return layer
}
